export type DispatchToastProps = {
  title: string
  message?: string
  variant?: 'success' | 'error'
  autoHide?: boolean
  autoHideDuration?: number
}

export const dispatchToaster = ({
  title,
  message = undefined,
  variant = 'success',
  autoHide,
  autoHideDuration = 5000
}: DispatchToastProps) => {
  const event = new CustomEvent(GLOBAL_TOAST_EVENT_NAME, {
    detail: {
      title,
      message,
      variant,
      autoHide,
      autoHideDuration
    }
  })

  window.dispatchEvent(event)
}

export const GLOBAL_TOAST_EVENT_NAME = 'swile-global-toaster'
